<ng-template #menuActions>
  <pxc-menu-actions [actions]="actions" [entity]="user" />
</ng-template>

<ng-container *transloco="let t">
  <button
    class="box-border! w-full rounded-xl! hover:bg-background-active! py-0.5! pr-3! whitespace-nowrap"
    tuiCell="m"
    tuiDropdownAuto
    tuiHintDirection="end"
    type="button"
    [ngClass]="collapsed ? 'pl-4!' : 'pl-3!'"
    [tuiDropdown]="menuActions"
    [tuiDropdownSided]="!isSidebarDrawer()"
    [tuiHint]="collapsed ? t('Votre compte') : null">
    <pxc-avatar class="size-6! transition-all" [name]="user | userName" [size]="Size.TINY" />
    <span class="font-medium!" tuiFade tuiTitle [animateFade]="!collapsed">
      {{ user | userName }}
      <span tuiSubtitle>{{ user.mailAddress }}</span>
    </span>
    <tui-icon class="text-base text-foreground-quaternary" icon="@tui.ellipsis-vertical" [animateFade]="!collapsed" />
  </button>
</ng-container>
